export default Object.freeze({
	REPORT_TABLES: {
		REPORT: 'report',
		CHART: 'chart',
	},
});
